import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { up } from '../../../theme';

export const classes = {
  root: 'root',
  profileBox: 'profileBox',
  mainTitle: 'mainTitle',
  mainBox: 'mainBox',
  subBox: 'subBox',
  box: 'box',
  title: 'title',
  addUser: 'addUser',
  memberGrid: 'memberGrid',
  linearProgress: 'linearProgress',
  chart: 'chart',
  creditTypo: 'creditTypo',
  profileTitle: 'profileTitle',
  titleGrid: 'titleGrid',
  individualGrid: 'individualGrid',
  icon: 'icon',
  backToHomeIcon: 'backToHomeIcon',
  individualInnerGrid: 'individualInnerGrid',
  btn: 'btn',
  gridPadding: 'gridPadding',
  avatar: 'avatar',
  addUserBox: 'addUserBox',
  addIcon: 'addIcon',
  textFieldContainer: 'textFieldContainer',
  cardComponent: 'cardComponent',
  errorCardComponent: 'errorCardComponent',
  cardHeader: 'cardHeader',
  addUserBtn: 'addUserBtn',
  cardContent: 'cardContent',
  subTitle: 'subTitle',
  closeAction: 'closeAction',
  emailTextFieldText: 'emailTextFieldText',
  textField: 'textField',
  input: 'input',
  progressBar: 'progressBar',
  checkBox: 'checkBox',
  countryDropdownTypo: 'countryDropdownTypo',
  loaderBox: 'loaderBox',
  roleTextField: 'roleTextField',
  formHelperText: 'formHelperText',
};

export const EmailLabelTypo = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  paddingBottom: theme.spacing(0.5),
}));

export const RoleLabelTypo = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  paddingBottom: theme.spacing(0.5),
  paddingTop: theme.spacing(1.5),
}));

export const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {
    background: theme.palette.secondaryWhite.main,
    [up('xs')]: {
      height: `calc(100vh - ${theme.spacing(6)});`,
    },
  },
  [`& .${classes.profileBox}`]: {
    [up('xs')]: {
      marginLeft: '20px',
      marginRight: '20px',
      height: '83vh',
    },
    [up('sm')]: {
      marginLeft: '20px',
      marginRight: '20px',
      height: '68vh',
    },
    [up('md')]: {
      marginLeft: '20px',
      marginRight: '20px',
      height: '70vh',
    },
    [up('lg')]: {
      marginLeft: '20px',
      marginRight: '20px',
      height: '72vh',
    },
    [up('xl')]: {
      marginLeft: '20px',
      marginRight: '20px',
      height: '75vh',
    },
    [up('xxl')]: {
      marginLeft: '40px',
      marginRight: '40px',
      height: '76vh',
    },
    borderRadius: '5px',
    border: `1px solid ${theme.palette.secondaryBlack.lighter}`,
    overflow: 'auto',
    scrollbarWidth: 'thin',
    '&::-webkit-scrollbar': {
      width: '0.4em',
    },
    '&::-webkit-scrollbar-track': {
      background: '#D9D9D9',
      borderRadius: '5px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#868686',
      borderRadius: '5px',
    },
  },
  [`& .${classes.box}`]: {
    [up('xs')]: {
      margin: '15px 17px 15px 17px',
    },
    [up('sm')]: {
      margin: '16px 19px 16px 19px',
    },
    [up('md')]: {
      margin: '14px 19px 14px 19px',
    },
    [up('lg')]: {
      margin: '16px 20px 16px 20px',
    },
    [up('xl')]: {
      margin: '18px 23px 18px 23px',
    },
    [up('xxl')]: {
      margin: '20px 25px 20px 25px',
    },
  },
  [`& .${classes.title}`]: {
    color: theme.palette.dynamicBlack.semiDark,
    [up('xs')]: {
      marginBottom: '7px',
    },
    [up('sm')]: {
      marginBottom: '8px',
    },
    [up('md')]: {
      marginBottom: '9px',
    },
    [up('lg')]: {
      marginBottom: '10px',
    },
    [up('xl')]: {
      marginBottom: '11px',
    },
    [up('xxl')]: {
      marginBottom: '13px',
    },
  },
  [`& .${classes.titleGrid}`]: {
    borderRadius: '5px',
    background: theme.palette.lunarBase.lightest,
    [up('xs')]: {
      marginBottom: '20px',
    },
    [up('sm')]: {
      marginBottom: '25px',
    },
    [up('md')]: {
      marginBottom: '30px',
    },
    [up('lg')]: {
      marginBottom: '35px',
    },
    [up('xl')]: {
      marginBottom: '40px',
    },
    [up('xxl')]: {
      marginBottom: '45px',
    },
  },
  [`& .${classes.individualGrid}`]: {
    [up('xs')]: {
      padding: '14px 0px 14px 14px',
    },
    [up('sm')]: {
      padding: '16px 0px 16px 16px',
    },
    [up('md')]: {
      padding: '18px 0px 18px 18px',
    },
    [up('lg')]: {
      padding: '20px 0px 20px 20px',
    },
    [up('xl')]: {
      padding: '22px 0px 22px 22px',
    },
    [up('xxl')]: {
      padding: '24px 0px 24px 24px',
    },
  },
  [`& .${classes.icon}`]: {
    [up('xs')]: {
      width: '13px',
      height: '13px',
      marginTop: '1.6px',
    },
    [up('sm')]: {
      width: '15px',
      height: '15px',
      marginTop: '2.4px',
    },
    [up('md')]: {
      width: '18px',
      height: '18px',
      marginTop: '1.6px',
    },
    [up('lg')]: {
      width: '20px',
      height: '20px',
      marginTop: '3.2px',
    },
    [up('xl')]: {
      width: '22px',
      height: '22px',
      marginTop: '4.8px',
    },
    [up('xxl')]: {
      width: '24px',
      height: '24px',
      marginTop: '3.2px',
    },
  },
  [`& .${classes.individualInnerGrid}`]: {
    [up('xs')]: {
      paddingLeft: '12px',
    },
    [up('sm')]: {
      paddingLeft: '14px',
    },
    [up('md')]: {
      paddingLeft: '14px',
    },
    [up('lg')]: {
      paddingLeft: '16px',
    },
    [up('xl')]: {
      paddingLeft: '16px',
    },
    [up('xxl')]: {
      paddingLeft: '18px',
    },
  },
  [`& .${classes.btn}`]: {
    boxShadow: 'none',
    background: theme.palette.lunarBase.semiLight,
    color: theme.palette.dynamicBlack.main,
    ':hover': {
      background: theme.palette.lunarBase.semiLight,
      color: '1E1E1E',
    },
    [up('xs')]: {
      width: '144px',
      height: '30px',
      marginBottom: '10px',
    },
    [up('sm')]: {
      width: '159px',
      height: '33px',
      margin: '20px 0px',
    },
    [up('md')]: {
      width: '156px',
      height: '34px',
      margin: '20px 0px',
    },
    [up('lg')]: {
      width: '165px',
      height: '37px',
      margin: '22px 0px',
    },
    [up('xl')]: {
      width: '185px',
      height: '40px',
      margin: '23px 0px',
    },
    [up('xxl')]: {
      width: '209px',
      height: '44px',
      margin: '24px 0px',
    },
  },
  [`& .${classes.gridPadding}`]: {
    paddingLeft: '37.6px',
  },
  [`& .${classes.avatar}`]: {
    marginRight: '16px',
    [up('xs')]: {
      width: '19px',
      height: '19px',
    },
    [up('sm')]: {
      width: '20px',
      height: '20px',
    },
    [up('md')]: {
      width: '25px',
      height: '25px',
    },
    [up('lg')]: {
      width: '33px',
      height: '33px',
    },
    [up('xl')]: {
      width: '35px',
      height: '35px',
    },
    [up('xxl')]: {
      width: '45px',
      height: '45px',
    },
  },
  [`& .${classes.addUserBox}`]: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginTop: '0.8vh',
    [up('xs')]: {
      marginBottom: '20px',
    },
    [up('sm')]: {
      marginBottom: '25px',
    },
    [up('md')]: {
      marginBottom: '30px',
    },
    [up('lg')]: {
      marginBottom: '35px',
    },
    [up('xl')]: {
      marginBottom: '40px',
    },
    [up('xxl')]: {
      marginBottom: '45px',
    },
  },
  [`& .${classes.addIcon}`]: {
    color: theme.palette.primary.main,
    cursor: 'pointer',
    marginRight: '0.8vh',
    [up('xs')]: {
      width: '11px',
      height: '11px',
    },
    [up('sm')]: {
      width: '12px',
      height: '12px',
    },
    [up('md')]: {
      width: '13px',
      height: '13px',
    },
    [up('lg')]: {
      width: '14px',
      height: '14px',
    },
    [up('xl')]: {
      width: '15px',
      height: '15px',
    },
    [up('xxl')]: {
      width: '16px',
      height: '16px',
    },
  },
  [`& .${classes.textFieldContainer}`]: {
    [up('xs')]: {
      margin: '10px 0px',
    },
    [up('sm')]: {
      margin: '10px 0px',
    },
    [up('md')]: {
      margin: '15px 0px',
    },
    [up('lg')]: {
      margin: '20px 0px',
    },
    [up('xl')]: {
      margin: '25px 0px',
    },
    [up('xxl')]: {
      margin: '30px 0px',
    },
  },
  [`& .${classes.cardComponent}`]: {
    borderRadius: '5px',
    [up('xs')]: {
      width: '55vw',
      height: '60vh',
    },
    [up('sm')]: {
      width: '56vw',
      height: '50vh',
    },
    [up('md')]: {
      width: '44vw',
      height: '52vh',
    },
    [up('lg')]: {
      width: '32.042vw',
      height: '63vh',
    },
    [up('xl')]: {
      width: '27.604vw',
      height: '50vh',
    },
    [up('xxl')]: {
      width: '33.854vw',
      height: '54vh',
    },
  },
  [`& .${classes.errorCardComponent}`]: {
    borderRadius: '5px',
    [up('xs')]: {
      width: '295px',
      height: '345px',
    },
    [up('sm')]: {
      width: '410px',
      height: '340px',
    },
    [up('md')]: {
      width: '425px',
      height: '340px',
    },
    [up('lg')]: {
      width: '500px',
      height: '385px',
    },
    [up('xl')]: {
      width: '530px',
      height: '425px',
    },
    [up('xxl')]: {
      width: '650px',
      height: '480px',
    },
  },
  [`& .${classes.cardHeader}`]: {
    background: theme.palette.lunarBase.lighter,
    borderBottom: `1px solid ${theme.palette.lunarBase.lightest}`,
  },
  [`& .${classes.addUserBtn}`]: {
    ':hover': {
      background: theme.palette.primary.main,
      color: 'white',
    },
    [up('xs')]: {
      width: '70px',
      height: '25px',
      marginTop: '29px',
    },
    [up('sm')]: {
      width: '74px',
      height: '24px',
      marginTop: '30px',
    },
    [up('md')]: {
      width: '92px',
      height: '26px',
      marginTop: '30px',
    },
    [up('lg')]: {
      width: '105px',
      height: '35px',
      marginTop: '35px',
    },
    [up('xl')]: {
      width: '115px',
      height: '40px',
      marginTop: '40px',
    },
    [up('xxl')]: {
      width: '133px',
      height: '52px',
      marginTop: '45px',
    },
  },
  [`& .${classes.cardContent}`]: {
    [up('xs')]: {
      margin: '4px 0px 0px',
    },
    [up('sm')]: {
      margin: '4px 2px 0px',
    },
    [up('md')]: {
      margin: '5px 2px 0px',
    },
    [up('lg')]: {
      margin: '10px 5px 0px',
    },
    [up('xl')]: {
      margin: '13px 8px 0px',
    },
    [up('xxl')]: {
      margin: '18px 11px 0px',
    },
  },
  [`& .${classes.subTitle}`]: {
    color: theme.palette.shoeWax.dark,
    [up('xs')]: {
      marginBottom: theme.spacing(1),
    },
    [up('sm')]: {
      marginBottom: theme.spacing(1.3),
    },
    [up('md')]: {
      marginBottom: theme.spacing(1.5),
    },
    [up('lg')]: {
      marginBottom: theme.spacing(1.5),
    },
    [up('xl')]: {
      marginBottom: theme.spacing(2),
    },
    [up('xxl')]: {
      marginBottom: theme.spacing(2.5),
    },
  },
  [`& .${classes.closeAction}`]: {
    cursor: 'pointer',
    [up('xs')]: {
      width: '16px',
      height: '16px',
    },
    [up('sm')]: {
      width: '18px',
      height: '18px',
    },
    [up('md')]: {
      width: '20px',
      height: '20px',
    },
    [up('lg')]: {
      width: '22px',
      height: '22px',
    },
    [up('xl')]: {
      width: '23px',
      height: '23px',
    },
    [up('xxl')]: {
      width: '24px',
      height: '24px',
    },
  },
  [`& .${classes.emailTextFieldText}`]: {
    fontWeight: 500,
    paddingBottom: theme.spacing(1.5),
  },
  [`& .${classes.roleTextField}`]: {
    fontWeight: 500,
    paddingBottom: theme.spacing(1.5),
    paddingTop: theme.spacing(1.5),
  },
  [`& .${classes.textField}`]: {
    '& .MuiFormHelperText-root': {
      marginLeft: '0px',
    },
    '& .MuiInputBase-input': {
      [up('xs')]: {
        height: '6px',
      },
      [up('sm')]: {
        height: '13px',
      },
      [up('md')]: {
        height: '13px',
      },
      [up('lg')]: {
        height: '17px',
      },
      [up('xl')]: {
        height: '25px',
      },
      [up('xxl')]: {
        height: '34px',
      },
    },
  },

  [`& .${classes.progressBar}`]: {
    [up('xs')]: {
      width: '45vw',
      height: '1vh',
    },
    [up('sm')]: {
      width: '23vw',
      height: '0.8vh',
    },
    [up('md')]: {
      width: '17vw',
      height: '1.3vh',
    },
    [up('lg')]: {
      width: '17vw',
      height: '1.7vh',
    },
    [up('xl')]: {
      width: '17vw',
      height: '1.29vh',
    },
    [up('xxl')]: {
      width: '15vw',
      height: '1.29vh',
    },
  },
  [`& .${classes.checkBox}`]: {
    padding: '1px 8px',
  },
  [`& .${classes.countryDropdownTypo}`]: {
    color: 'rgba(211, 47, 47, 1)',
    margin: '3px 14px 0px',
  },
  [`& .${classes.mainBox}`]: {
    backgroundColor: 'rgba(255, 255, 255, 1)',
    [up('xs')]: {
      height: `calc(100vh - ${theme.spacing(6)});`,
    },
  },
  [`& .${classes.subBox}`]: {
    display: 'flex',
    alignItems: 'center',
    [up('xs')]: {
      padding: '16px 21px 6px',
    },
    [up('sm')]: {
      padding: '18px 22px 8px',
    },
    [up('md')]: {
      padding: '19px 23px 11px',
    },
    [up('lg')]: {
      padding: '23px 23px 12px',
    },
    [up('xl')]: {
      padding: '27px 23px 14px',
    },
    [up('xxl')]: {
      padding: '32px 43px 16px',
    },
  },
  [`& .${classes.backToHomeIcon}`]: {
    borderRadius: '5px',
    backgroundColor: theme.palette.dynamicBlack.lighter,
    '&:hover': { backgroundColor: theme.palette.dynamicBlack.light },
  },
  [`& .${classes.profileTitle}`]: {
    borderRadius: '5px',
    background: theme.palette.primary.lightest,
    [up('xs')]: {
      marginBottom: '4px',
    },
    [up('sm')]: {
      marginBottom: '5.6px',
    },
    [up('md')]: {
      marginBottom: '7.2px',
    },
    [up('lg')]: {
      marginBottom: '8px',
    },
    [up('xl')]: {
      marginBottom: '10.4px',
    },
  },
  [`& .${classes.memberGrid}`]: {
    borderRadius: '5px',
    background: theme.palette.lunarBase.lightest,
  },
  [`& .${classes.addUser}`]: {
    cursor: 'pointer',
    color: theme.palette.primary.main,
  },
  [`& .${classes.chart}`]: {
    height: '300px',
    width: '100%',
    backgroundColor: 'rgba(134, 134, 134, 0.05)',
    [up('xs')]: {
      marginBottom: '13.6px',
    },
    [up('sm')]: {
      marginBottom: '21.6px',
    },
    [up('md')]: {
      marginBottom: '29.6px',
    },
    [up('lg')]: {
      marginBottom: '37.6px',
    },
    [up('xl')]: {
      marginBottom: '45.6px',
    },
  },
  [`& .${classes.creditTypo}`]: {
    color: theme.palette.shoeWax.darker,
    [up('xs')]: {
      marginTop: '8px',
    },
    [up('sm')]: {
      marginTop: '9.6px',
    },
    [up('md')]: {
      marginTop: '12px',
    },
    [up('lg')]: {
      marginTop: '13.6px',
    },
    [up('xl')]: {
      marginTop: '15.2px',
    },
    [up('xxl')]: {
      marginTop: '16px',
    },
  },
  [`& .${classes.linearProgress}`]: {
    [up('xs')]: {
      marginBottom: '10.4px',
    },
    [up('sm')]: {
      marginY: '20px',
    },
    [up('md')]: {
      marginY: '20px',
    },
    [up('lg')]: {
      marginY: '22px',
    },
    [up('xl')]: {
      marginY: '23.2px',
    },
    [up('xxl')]: {
      marginY: '24px',
    },
  },
  [`& .${classes.loaderBox}`]: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
  },
  [`& .${classes.formHelperText}`]: {
    marginLeft: theme.spacing(1.5),
    color: '#d32f2f',
  },
}));
